import { UserRewardType } from 'v2/constants';
import { enumToSelect } from 'v2/utils';

export const rewardsOptions = enumToSelect(UserRewardType);
